import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxJsonViewerModule } from 'ngx-json-viewer-scrolling';
import { AboutDialogComponent } from './about-dialog/about-dialog.component';
import { AvatarComponent } from './avatar/avatar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ButtonSetComponent } from './buttons/button-set/button-set.component';
import { ButtonComponent } from './buttons/button/button.component';
import { FabButtonSetComponent } from './buttons/fab-button-set/fab-button-set.component';
import { CardComponent } from './card/card.component';
import { ChatComponent } from './chat/chat.component';
import { InputBarComponent } from './chat/input-bar/input-bar.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { CookiePolicyDialogComponent } from './cookie-policy-dialog/cookie-policy-dialog.component';
import { CookiePolicyFooterComponent } from './cookie-policy-footer/cookie-policy-footer.component';
import { DashboardMenuComponent } from './dashboard-menu/dashboard-menu.component';
import { DashboardTotalizerComponent } from './dashboard-totalizer/dashboard-totalizer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FileExportDialogComponent } from './file-export-dialog/file-export-dialog.component';
import { FileImportDialogComponent } from './file-import-dialog/file-import-dialog.component';
import { FlippingLogoComponent } from './flipping-logo/flipping-logo.component';
import { CheckboxTreeComponent } from './forms/checkbox-tree/checkbox-tree.component';
import { FormFieldDataService } from './forms/form-field/form-field-data.service';
import { FormFieldComponent } from './forms/form-field/form-field.component';
import { ImagePickerDialogComponent } from './forms/form-field/image-picker-dialog/image-picker-dialog.component';
import { LovDialogComponent } from './forms/form-field/lov-dialog/lov-dialog.component';
import { FormHeaderComponent } from './forms/form-header/form-header.component';
import { GlideDialogComponent } from './glide-dialog/glide-dialog.component';
import { FilterFieldComponent } from './grids/filter-field/filter-field.component';
import { GridComponent } from './grids/grid/grid.component';
import { SortArrowComponent } from './grids/sort-arrow/sort-arrow.component';
import { LanguageChooserComponent } from './header-widgets/language-chooser/language-chooser.component';
import { ProfileSectionComponent } from './header-widgets/profile-section/profile-section.component';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { IconLabelComponent } from './icon-label/icon-label.component';
import { IconComponent } from './icon/icon.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { InformationDialogComponent } from './information-dialog/information-dialog.component';
import { JsonViewerComponent } from './json-viewer/json-viewer.component';
import { LanguageShortLabel } from './language-short-label.pipe';
import { CanvasLayoutComponent } from './layouts/canvas-layout/canvas-layout.component';
import { MobilePageLayoutComponent } from './layouts/mobile-page-layout/mobile-page-layout.component';
import { PageLayoutComponent } from './layouts/page-layout/page-layout.component';
import { MaterialModule } from './material-module';
import { NotificationDataService } from './notification-data.service';
import { OwnedByPrincipalPipe } from './pipes/owned-by-principal.pipe';
import { NoPermissionsPageComponent } from './private-area/no-permissions-page/no-permissions-page.component';
import { PrivateAreaCanvasComponent } from './private-area/private-area-canvas/private-area-canvas.component';
import { HeaderComponent } from './private-area/private-area-header/private-area-header.component';
import { PublicAreaFooterComponent } from './public-area-footer/public-area-footer.component';
import { AboutComponent } from './public-area/about/about.component';
import { PublicAreaCanvasComponent } from './public-area/public-area-canvas/public-area-canvas.component';
import { PublicAreaHeaderComponent } from './public-area/public-area-header/public-area-header.component';
import { AccessDeniedScreenComponent } from './screeens/access-denied-screen/access-denied-screen.component';
import { LoadingScreenComponent } from './screeens/loading-screen/loading-screen.component';
import { UnsupportedResolutionScreenComponent } from './screeens/unsupported-resolution-screen/unsupported-resolution.component';
import { TreeMenuComponent } from './tree-menu/tree-menu.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatCarouselModule } from '@ngbmodule/material-carousel';
import { TileSetComponent } from './tile-set/tile-set.component';
import { DisabledUserPageComponent } from './private-area/disabled-user-page/disabled-user-page.component';
import { StepperComponent } from './stepper/stepper.component';
import { DialogComponent } from './dialog/dialog.component';
import { DataImporterComponent } from './data-importer/data-importer.component';
import { ImporterComponent } from './importer/importer.component';
import { FilePreviewerComponent } from './file-previewer/file-previewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AngularResizedEventModule } from 'angular-resize-event';
import { DataImporterFormComponent } from './data-importer/data-importer-form/data-importer-form.component';
import { DataImporterPreviewComponent } from './data-importer/data-importer-preview/data-importer-preview.component';
import { DataImporterDescriptorComponent } from './data-importer/data-importer-descriptor/data-importer-descriptor.component';
import { PageLayoutNewComponent } from './layouts/page-layout-new/page-layout-new.component';
import { DynamicFormFieldComponent } from './forms/form-field/dynamic-form-field/dynamic-form-field.component';

@NgModule({
  declarations: [
    OwnedByPrincipalPipe,
    LanguageShortLabel,

    //form
    FormFieldComponent,
    CheckboxTreeComponent,
    ImagePickerDialogComponent,
    LovDialogComponent,
    //filter
    FilterFieldComponent,
    //grid
    GridComponent,
    SortArrowComponent,
    //buttons
    IconComponent,
    ButtonComponent,
    ButtonSetComponent,
    FabButtonSetComponent,
    //layout
    CanvasLayoutComponent,
    PageLayoutComponent,
    MobilePageLayoutComponent,
    //views
    TreeMenuComponent,
    AboutDialogComponent,
    CookiePolicyDialogComponent,
    ConfirmationDialogComponent,
    InformationDialogComponent,
    GlideDialogComponent,
    FileImportDialogComponent,
    FlippingLogoComponent,
    ProfileSectionComponent,
    FormHeaderComponent,
    PublicAreaHeaderComponent,
    HeaderComponent,
    InputBarComponent,
    //screens
    LoadingScreenComponent,
    UnsupportedResolutionScreenComponent,
    AccessDeniedScreenComponent,
    //pages
    LanguageChooserComponent,
    ImageCropperComponent,
    BreadcrumbsComponent,
    IconLabelComponent,
    DashboardComponent,
    DashboardTotalizerComponent,
    CardComponent,
    DashboardMenuComponent,
    HorizontalMenuComponent,
    ChatComponent,
    //canvas
    PublicAreaCanvasComponent,
    PrivateAreaCanvasComponent,
    PublicAreaFooterComponent,
    CookiePolicyFooterComponent,

    //PhoneNumberInputComponent //TODO
    AboutComponent,
    JsonViewerComponent,
    FileExportDialogComponent,
    NoPermissionsPageComponent,
    AvatarComponent,
    TileSetComponent,
    DisabledUserPageComponent,
    StepperComponent,
    DialogComponent,
    DataImporterComponent,
    ImporterComponent,
    FilePreviewerComponent,
    DataImporterFormComponent,
    DataImporterPreviewComponent,
    DataImporterDescriptorComponent,
    PageLayoutNewComponent,
    DynamicFormFieldComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,//serve a FormField di tipo CHIPSET
    HttpClientModule,//serve al TranslateModule

    // Material
    MaterialModule,

    // 3rd party
    TextMaskModule,
    NgxJsonViewerModule,
    RecaptchaModule,
    MatCarouselModule,
    PdfViewerModule,
    AngularResizedEventModule,

    // i18n
    TranslateModule
  ],
  providers: [
    FormFieldDataService,
    NotificationDataService
  ],
  /* WARNING: Component should be declared as an entry component to survive tree shaking. */
  entryComponents: [ 
    DialogComponent,
    AboutDialogComponent,
    CookiePolicyDialogComponent,
    ConfirmationDialogComponent,
    InformationDialogComponent,
    GlideDialogComponent,
    FileImportDialogComponent,
    ImagePickerDialogComponent,
    LovDialogComponent
    //PhoneNumberInputComponent //TODO
  ],
  exports: [                 //<- componenti da utilizzare anche fuori da questo modulo
    CardComponent,
    TileSetComponent,
    FormFieldComponent,
    DynamicFormFieldComponent,
    FilterFieldComponent,
    IconComponent,
    IconLabelComponent,
    ButtonComponent,
    ButtonSetComponent,
    FabButtonSetComponent,
    CanvasLayoutComponent,
    PageLayoutComponent,
    MobilePageLayoutComponent,
    PageLayoutNewComponent,
    TreeMenuComponent,
    DashboardComponent,
    DashboardMenuComponent,
    BreadcrumbsComponent,
    StepperComponent,
    LoadingScreenComponent,
    AboutDialogComponent,
    FlippingLogoComponent,
    GridComponent,
    LanguageChooserComponent,
    HorizontalMenuComponent,
    //views
    //screens
    LoadingScreenComponent,
    UnsupportedResolutionScreenComponent,
    AccessDeniedScreenComponent,
    DashboardTotalizerComponent,
    ChatComponent,
    //canvas
    PublicAreaCanvasComponent,
    PrivateAreaCanvasComponent,
    PublicAreaFooterComponent,
    CookiePolicyFooterComponent,
    JsonViewerComponent,
    AvatarComponent,
    ImporterComponent,
    DataImporterComponent,
    FilePreviewerComponent,

    RecaptchaModule, // Deve essere esportato
    MatCarouselModule,
    PdfViewerModule,
    AngularResizedEventModule
  ],
})
export class AngularUiCommonModule { }
